export const GENDER_VALUES = ['male', 'female', 'other', 'prefer_not_to_say'] as const;

export type Gender = (typeof GENDER_VALUES)[number];

export function isGender(value: string | null | undefined): value is Gender {
  return value != null && (GENDER_VALUES as readonly string[]).includes(value);
}
